<template>
  <div class="card">
    <div class="card-body">
      <div class="pb-5" style="display: flex; justify-content: space-between; align-items: center;">
        <h5 class="text-primary pt-2">Sipariş Özeti</h5>
        <b-button @click="clearAll()" style="font-size: 13px; color: rgb(244, 106, 106); padding-left: 0"
                  variant="transparent"
        ><i class="pb-3 mdi mdi-trash-can me-1"></i>Tüm Ürünleri Sil
        </b-button>
      </div>
      <div class="table-responsive" style="max-height: 350px; overflow-y: auto;">
        <table class="table align-middle mb-0 table-nowrap">
          <thead>
          <tr class="table-info">
            <th>Sıra</th>
            <th>Stok Bilgileri</th>
            <th class="text-center" v-if="erpSettings.cartShowBalance">Bakiye</th>
            <th class="text-center">Koli İçeriği</th>
            <th class="text-center">Miktar</th>
            <th class="text-center">Birim Fiyat</th>
            <th class="text-center" v-if="erpSettings.netsisCurrencySale">Dövizli Birim Fiyat</th>
            <th class="text-center">İskonto 1</th>
            <th class="text-center">İskonto 2</th>
            <th class="text-center">KDV</th>
            <th class="text-center">Tutar</th>
            <th class="text-center" v-if="erpSettings.netsisCurrencySale">Dövizli Tutar</th>
            <th class="text-center">Sil</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,i) in cartList" :key="item.stockCode">
            <td>
              {{ i + 1 }}
            </td>
            <td>
              <h5 class="font-size-14 text-truncate">
                <router-link
                    :to="'/product-detail/' + item.stockCode"
                    target='_blank'
                    class="text-dark"
                >{{ item.stockName }}
                </router-link
                >
              </h5>
              <p class="mb-0">
                Stok Kodu :
                <span class="fw-medium">{{ item.stockCode }}</span>
              </p>
              <p class="mb-0" v-if="item.producerCode">
                Üretici Kodu :
                <span class="fw-medium">{{ item.producerCode }}</span>
              </p>
            </td>
            <td class="text-center" v-if="erpSettings.cartShowBalance">{{ item.stockBalance }}</td>
            <td class="text-center"> {{item.denominator1}}</td>
            <td class="text-center">
              <div class="d-flex justify-content-center">
                <input
                    type="number"
                    :value="item.quantity"
                    :min="1"
                    class="form-control"
                    style="width: 80px"
                    @keydown.enter="
                      (e) =>
                        cartStockChange(item, parseInt(e.target.value))
                    "
                    @change="(e) => cartStockChange(item, parseInt(e.target.value))"
                />
              </div>
            </td>

            <td class="text-center">
              <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                {{ numberConverter(item.unitPrice * (100 - item.discount1 + item.discount2) / 100) + " ₺" }}
              </h5>
              <del v-if="item.discount1 || item.discount2">{{ numberConverter(item.unitPrice) + " ₺" }}</del>
              <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.unitPrice) + " ₺" }} </span>
            </td>
            <td v-if="erpSettings.netsisCurrencySale" class="text-center">
              <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                {{
                  numberConverter(item.currencyUnitPrice * (100 - item.discount1 + item.discount2) / 100) + fetchCurrencyLabel(item.currencyType)
                }}
              </h5>
              <del v-if="item.discount1 || item.discount2">
                {{ numberConverter(item.currencyUnitPrice) + fetchCurrencyLabel(item.currencyType) }}
              </del>
              <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.currencyUnitPrice) + fetchCurrencyLabel(item.currencyType) }} </span>

            </td>

            <td class="text-center">{{ '%' + item.discount1 }}</td>
            <td class="text-center">{{ '%' + item.discount2 }}</td>
            <td class="text-center">{{ '%' + item.vat }}</td>
            <td class="text-center">
              <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                {{ numberConverter(item.amount * (100 - item.discount1 + item.discount2) / 100) + " ₺" }}
              </h5>
              <del v-if="item.discount1 || item.discount2">{{ numberConverter(item.amount) + " ₺" }}</del>
              <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.amount) + " ₺" }} </span>

            </td>
            <td v-if="erpSettings.netsisCurrencySale" class="text-center">
              <h5 v-if="item.discount1 || item.discount2" class="font-size-14 text-truncate">
                {{
                  numberConverter(item.currencyAmount * (100 - item.discount1 + item.discount2) / 100) + fetchCurrencyLabel(item.currencyType)
                }}
              </h5>
              <del v-if="item.discount1 || item.discount2" class="">
                {{ numberConverter(item.currencyAmount) + fetchCurrencyLabel(item.currencyType) }}
              </del>
              <span v-if="!item.discount1 && !item.discount2"> {{ numberConverter(item.currencyAmount) + fetchCurrencyLabel(item.currencyType) }} </span>

            </td>
            <td class="text-center">
              <v-btn
                  style="background-color: rgb(244, 106, 106)"
                  small
                  href="javascript:void(0);"
                  class="action-icon text-light"
                  @click="cartStockRemove(item)"

              >
                <i class="mdi mdi-trash-can font-size-14"></i>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <h5 class="text-primary">Tutar Özeti</h5>

          <div class="table-responsive">
            <table class="table mb-0">
              <tbody>
              <tr>
                <td>Brüt Tutar</td>
                <td class="text-right">{{ numberConverter(cartTotalInfo.grossTotal) + " ₺" }}</td>
              </tr>
              <tr>
                <td>İskonto</td>
                <td class="text-right">{{ numberConverter(cartTotalInfo.discountTotal) + " ₺" }}</td>
              </tr>
              <tr>
                <td>Ara Toplam</td>
                <td class="text-right">{{ numberConverter(cartTotalInfo.subTotal) + " ₺" }}</td>
              </tr>
              <tr>
                <td>KDV</td>
                <td class="text-right">{{ numberConverter(cartTotalInfo.kdvTotal) + " ₺" }}</td>
              </tr>
              <tr>
                <th>Toplam Tutar :</th>
                <th class="text-right">{{ numberConverter(cartTotalInfo.total) + " ₺" }}</th>
              </tr>
              </tbody>
            </table>
          </div>

          <h5
              v-if="erpSettings.cartProjectProcess"
              class="mt-5 text-primary">Proje Seçimi</h5>
          <search-select
              v-if="erpSettings.cartProjectProcess"
              :search-type="'project'"
              @itemChange="(e) => (selectedProject = e)"
              :placeholder="'Proje Arayın...'">
          </search-select>
        </div>
        <div class="col-lg-6">
          <div class="row">

            <div class="col-lg-6" v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'">
                <h5
                    class="mt-0 text-primary">Plasiyer Seçimi</h5>
              <v-select
                  v-model="selectedSalesPersonCode"
                  placeholder="Tüm Plasiyerler"
                  clearable
                  solo
                  dense
                  filled
                  :items="salesPersonList"
                  :item-text="item => item.name"
                  :item-value="item => item.code"
              >
              </v-select>
            </div>
            <!--            <div class="col-lg-6">-->
            <!--              <h5 class="text-primary">Kargo Firması</h5>-->
            <!--              <v-select-->
            <!--                  v-model="shippingCompany"-->
            <!--                  filled-->
            <!--                  dense-->
            <!--                  solo-->
            <!--                  :items="shippingCompanyList"-->
            <!--                  :item-text="item => item.name"-->
            <!--                  :item-value="item => item.id"-->
            <!--              ></v-select>-->
            <!--            </div>-->
            <div class="col-lg-6">
              <h5 class="text-primary">Ödeme Yöntemi</h5>
              <v-select
                  v-model="paymentMethod"
                  filled
                  dense
                  solo
                  :items="paymentMethodList"
                  :item-text="item => item.name"
                  :item-value="item => item.id"
                  persistent-hint
                  @change="e => _cartPaymentMethodUpdate(e)"
              ></v-select>
            </div>
            <div class="col-lg-12">
            <h5 class="text-primary">Sipariş Notu</h5>
            <v-textarea
                v-model="descriptionValue"
                filled
                dense
                solo
                rows="3"
            ></v-textarea>
            </div>
            <div class="col-lg-12">
              <h5 class="text-primary">Sevk Adresi</h5>
              <v-checkbox v-model="shippingAddressIsDifferent" label="Farklı Sevk Adresi"></v-checkbox>
              <v-textarea
                  v-if="shippingAddressIsDifferent"
                  v-model="deliveryAddressValue"
                  filled
                  dense
                  solo
                  rows="3"
              ></v-textarea>
            </div>
            <div class="col-sm-12">
              <router-link :to="'/stock-list'">
                <b-button variant="transparent"
                ><i class="mdi mdi-arrow-left me-1"></i>Stoklara Dön
                </b-button>
              </router-link>

              <b-button class="float-right" variant="success" :disabled="!paymentMethod" @click="addConfirm"
              ><i class="mdi mdi-cart-arrow-right me-1"></i>
                {{
                  erpSettings.cartProjectProcess ? selectedProject ? "Kaydet" : "Siparişi Tamamla" : "Siparişi Tamamla"
                }}
              </b-button
              >
            </div>
            <!-- end col -->
          </div>
        </div>
      </div>
      <!-- end row-->
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import Swal from "sweetalert2";
import {numberConverter} from "../../../helpers";
import SearchSelect from "@/components/searchSelect.vue";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";

/**
 * Product-cart component
 */
export default {
  page: {
    title: "Sepet",
    meta: [{name: "description", content: "Sepet"}],
  },
  components: {SearchSelect},
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("shipping", ["shippingCompanyList"]),
    ...mapState("payment", ["paymentMethodList"]),
    ...mapState("cart", ["cartList", "current", "cartListMetaData"]),
    ...mapState("settings", ["erpSettings"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    ...mapState("current", ["salesPersonList"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {},
      body: {}
    })
    if (this.cartList.length < 1)
      this.$router.push({name: 'stock-list'})
    this.fetchShippingCompanyList({
      params: {},
      body: {}
    });
    this.fetchPaymentMethodList({
      params: {
        userId: this.user.UserId
      },
      body: {}
    })
  },
  data() {
    return {
      title: "Sepet",
      shippingCompany: null,
      shippingAddressIsDifferent: false,
      paymentMethod: null,
      items: [
        {
          text: "Sepet",
          active: true,
        },
      ],
      disableFields: false,
      cartTotalInfo: {
        grossTotal: 0,
        discountTotal: 0,
        subTotal: 0,
        kdvTotal: 0,
        total: 0,
        dovizliTotal: 0,
        dovizBirim: 0,
      },
      descriptionValue: null,
      deliveryAddressValue: null,
      selectedProject: null,
      selectedSalesPersonCode: null,
    };
  },
  methods: {
    numberConverter,
    ...mapActions("cart", [
      "cartStockUpdate",
      "cartStockDelete",
      "cartPaymentMethodUpdate"
    ]),
    ...mapActions("order", [
      "addOrder"
    ]),
    ...mapActions("shipping", [
      "fetchShippingCompanyList"
    ]),
    ...mapActions("payment", [
      "fetchPaymentMethodList"
    ]),
    ...mapActions("current",["fetchSalesPersonList"]),
    ...mapActions("project", ["projectUpdateCode"]),
    ...mapMutations("cart", ["setCartList","setCartListMetaData"]),
    expandImage(images) {
      this.$viewerApi({
        images: images,
      });
    },
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return '';
    },
    async cartStockChange(product, quantity = 1, discount1 = 0, discount2 = 0) {
      if (!this.current) {
        Swal.fire({
          title: "Ürün Adet Güncelleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      } else {
        await this.cartStockUpdate({
          params: {
            userId: this.user.UserId,
            currentCode: this.current.code
          },
          body: {
            "Id": product.id,
            "StockCode": product.stockCode,
            "Quantity": quantity,
            "Unit": 1,
            "Discount1": discount1,
            "Discount2": discount2
          }
        });
      }
    },
    async cartStockRemove(product) {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          stockCode: product.stockCode,
          //basketCode: null //sepet Kodu ise yollanacak
        },
        body: {}
      });
    },
    async clearAll() {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
        },
        body: {}
      });
    },
    async addConfirm() {
      if (this.selectedProject && this.erpSettings.cartProjectProcess) {
        await this._addOrder();
      } else if (!this.selectedProject && this.erpSettings.cartProjectProcess) {
        const confirm = await showProcessPromptMessage({
          title: 'Proje Seçimi Yapmadınız',
          text: "Siparişi proje olmadan onaylamak istediğinize emin misiniz ?",
        });

        if (confirm.isConfirmed) {
          let result = await this._addOrder();
          if (result.data.success) {
            showProcessSuccessMessage({
              title: 'Sipariş Onaylandı',
              text: "Sipariş onaylama işlemi başarılı",
            });
          } else {
            showProcessErrorMessage({
              title: 'Sipariş Onaylama Başarısız',
              text: result.data.message,
            });
          }
        }
      } else {
        await this._addOrder();
      }
    },

    async _addOrder() {
      if (this.user.RoleGroupId ===1 || this.user.RoleGroupId === '1'){
        if (!this.selectedSalesPersonCode) {
          showProcessErrorMessage({
            title: 'Plasiyer Seçimi Yapmadınız',
            text: "Plasiyer seçimi yapmadan sipariş veremezsiniz",
          });
          return;
        }
      }
      const result = await this.addOrder({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          ...(this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1' ? { salesPersonCode: this.selectedSalesPersonCode } : this.user.userInfo.salesPersonCode ? { salesPersonCode: this.user.userInfo.salesPersonCode } : {})
        },
        body: {
          "Order": {
            "Type": 1,
            "CurrentCode": this.current.code,
            "Description": this.descriptionValue,
            "DeliveryAddress": this.deliveryAddressValue,
            "ShippingCompanyId": this.shippingCompany,
            "PaymentMethodId": this.paymentMethod,
          },
          "OrderDetails": this.cartList,
        },
      });
      return result;
    },

    initCartTotalInfo() {
      if (this.cartList.length > 0) {
        this.cartTotalInfo = {
          grossTotal: 0,
          discountTotal: 0,
          subTotal: 0,
          kdvTotal: 0,
          total: 0,
          dovizliTotal: 0,
          dovizBirim: 0,
        };
        for (let i = 0; i < this.cartList.length; i++) {
          this.cartTotalInfo.dovizliTotal = this.cartList[i].currencyAmount;
          this.cartTotalInfo.dovizBirim = this.cartList[i].currencyUnitPrice;
          this.cartTotalInfo.grossTotal += this.cartList[i].amount;
          this.cartTotalInfo.kdvTotal += this.cartList[i].vatAmount;
          this.cartTotalInfo.discountTotal = this.cartList[i].discountAmount1 + this.cartList[i].discountAmount2 + this.cartList[i].paymentDiscountAmount
        }
        this.cartTotalInfo.subTotal = this.cartTotalInfo.grossTotal - this.cartTotalInfo.discountTotal;
        this.cartTotalInfo.total = this.cartTotalInfo.kdvTotal + this.cartTotalInfo.subTotal;
      }
    },
    async _cartPaymentMethodUpdate(paymentMethodId) {
      let result = await this.cartPaymentMethodUpdate({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          paymentMethodId: paymentMethodId
        }
      })
      this.setCartListMetaData(result.data.data);
      this.setCartList(result.data.data.cartDetails);
    }
  },
  watch: {
    selectedProject: async function (newVal) {
      await this.projectUpdateCode({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          ...(!(newVal === "" || newVal === null)) && {projectCode: newVal},

        }
      })
    },
    cartList: function (newVal) {
      if (newVal.length < 1) {
        this.$router.push({name: 'productSearch'})
      } else {
        this.initCartTotalInfo();
      }
    },
  },
};
</script>

<style scoped>
.i-card {
  position: relative;
  margin: 0 10px;
  height: 250px;
  background: #0D47A1;
  border-radius: 20px;
}

.i-card-bank {
  position: absolute;
  letter-spacing: 5px;
  left: 20px;
  top: 20px;
}

.i-card-number {
  position: absolute;
  letter-spacing: 10px;
  left: 20px;
  bottom: 80px;
}

.i-card-owner {
  position: absolute;
  letter-spacing: 5px;
  left: 20px;
  bottom: 20px;
}
</style>
